import "jquery";
import * as ko from "knockout";
import { ContactViewModel } from "../ViewModels/ContactViewModel";
import { ContactApi } from "../Apis/ContactApi";
import { GrowerConsultant } from "../Models/Employee/GrowerConsultant";
import { RegionalManager } from "../Models/Employee/RegionalManager";
import { forEach } from "lodash-es";

export class Contact {
    growerConsultant: ContactViewModel<GrowerConsultant>;
    regionalManager: ContactViewModel<RegionalManager>;
    contactApi: ContactApi;


    constructor() {

        this.contactApi = ContactApi.getInstance();
        this.growerConsultant = new ContactViewModel<GrowerConsultant>();
        this.regionalManager = new ContactViewModel<RegionalManager>();

        forEach($('*[data-model="growerConsultant"]'), e => {
            ko.applyBindings(this.growerConsultant, e);
        });
        forEach($('*[data-model="regionalManager"]'), e => {
            ko.applyBindings(this.regionalManager, e);
        });


        //$('*[data-model="growerConsultant"]')
        //$('')
        //if (this.$consultantAnchor) {
        //    try {

        //        console.log(this.$consultantAnchor[0]);
        //        ko.applyBindings(this.growerConsultant, this.$consultantAnchor[0]);

        //    } catch (e) {
        //        console.log(e);
        //    }


        //}
    }
    init(): void {
        this.contactApi.getGrowerConsultant().then((res) => {
            this.growerConsultant.consultant(res);
            this.growerConsultant.isLoading(false);
        });
        this.contactApi.getRegionalManager().then((res) => {
            this.regionalManager.consultant(res);
            this.regionalManager.isLoading(false);
        });

    }

}